import { createApi } from '@reduxjs/toolkit/query/react'
import { deviceAxiosQuery } from '../../utils/axios/device.axios'


export const profileApi = createApi({
    reducerPath: 'profile',
    baseQuery: deviceAxiosQuery(),
    endpoints: (builder) => ({
        getBillingDetails: builder.query<any, void>({
            query: () => ({
                url: `/leo/payments/billing/details`,
                method: 'GET',
            })
        }),
        getUserModels: builder.query<any, void>({
            query: () => ({
                url: `/ai-search-engine/user-enabled-ai-models`,
                method: 'PUT',
            })
        }),
        subscriptionUpdates: builder.mutation<any, string>({
            query: (status) => ({
                url: `/leo/payments/subscription/${status}`,
                method: 'PUT',
            }),
        }),
        configUpdate: builder.mutation<any, any>({
            query: (data) => ({
                url: `/ai-search-engine/user-search-config`,
                method: 'PUT',
                data: data
            }),
        }),
    }),
})

export const {
    useGetBillingDetailsQuery,
    useGetUserModelsQuery,
    useSubscriptionUpdatesMutation,
    useConfigUpdateMutation,
} = profileApi